import React, { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { setBreadcrumb } from "../../redux/slices/breadCrumb.slice";
import { Select, Switch, TextInput, Button } from "@mantine/core";
import { useClickOutside } from "@mantine/hooks";
import * as Yup from "yup";
import { Formik, ErrorMessage } from "formik";
import { notifications } from "@mantine/notifications";
import { useAddLocationsMutation } from "../../redux/slices/api.slice";
import { useLazyGetS3UrlQuery } from "../../redux/slices/api.slice";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Container from "../../components/Container";
const NewSpace = () => {
  const dispatch = useAppDispatch();
  const [addLocationMutation, { isLoading: isLoadingNewSite }] =
    useAddLocationsMutation();
  const [fetchS3URL] = useLazyGetS3UrlQuery();

  const initalOpTimes = {
    Monday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
    Tuesday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
    Wednesday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
    Thursday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
    Friday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
    Saturday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
    Sunday: {
      startHours: "08",
      startMinutes: "00",
      endHours: "05",
      endMinutes: "00",
      show: false,
      startUnit: "AM",
      endUnit: "PM",
    },
  };

  const [opentingTime, setOpeningTime] = useState(initalOpTimes);
  const [isloadingImg, setIsLoadingImg] = useState(false);
  const [isErrorImg, setIsErrorImg] = useState(false);
  const imgRef = useRef(null);

  const navigate = useNavigate();
  const handleUploadImages = async (e, setFieldValue, valueName) => {
    const file = e.target.files;
    const cloud = process.env.REACT_APP_CLOUDFRONT_URL;
    const timestamp = Math.floor(new Date().getTime() / 1000);
    const fileName = file[0].name.split(".")[0];
    const ext = file[0].name.split(".")[1];

    try {
      setIsLoadingImg(true);
      setIsErrorImg(false);
      const { data: URL } = await fetchS3URL({
        fileName: `${fileName}-${timestamp}.${ext}`,
      });

      const res = await fetch(URL, {
        method: "PUT",
        body: file[0],
      });
      if (res.ok) {
        setFieldValue(valueName, `${cloud}${fileName}-${timestamp}.${ext}`);
        imgRef.current = { name: file[0].name, size: file[0].size };
        setIsLoadingImg(false);
      } else {
        setFieldValue(valueName, "");
        setIsErrorImg(true);
      }
    } catch (e) {
      console.log("err", e);
      setIsLoadingImg(false);
      setIsErrorImg(true);
    }
  };

  const handleAddLocationSubmit = async (values, opTime, helpers) => {
    try {
      const result = await addLocationMutation({
        location: { ...values, openingTime: JSON.stringify(opTime) },
      });

      //@ts-ignore
      if (result.data) {
        notifications.show({
          title: "Success",
          message: "Location added successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (err) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
    helpers.resetForm();
    setOpeningTime(initalOpTimes);
    navigate("/");
  };

  const initialLocationValues = {
    name: "",
    imageURL: "",
    openingTime: null,
    address: "",
    description: "",
    ampm: "",
  };

  const addLocationValidationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    imageURL: Yup.string(),

    address: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  useEffect(() => {
    const crumbs = [
      { name: "Home", route: "/" },
      { name: "New Site", route: "" },
    ];
    dispatch(setBreadcrumb(crumbs));
  }, [dispatch]);

  return (
    <Container>
      <div className="relative  ">
        <Formik
          initialValues={initialLocationValues}
          onSubmit={(values, helpers) => {
            const opTime = Object.keys(opentingTime).reduce(
              (accumulator, day) => {
                const startTime = `${opentingTime[day].startHours}:${opentingTime[day].startMinutes}`;
                const endTime = `${opentingTime[day].endHours}:${opentingTime[day].endMinutes}`;
                const startUnit = opentingTime[day].startUnit;
                const endUnit = opentingTime[day].endUnit;
                accumulator[day] = opentingTime[day].show
                  ? `${startTime} ${startUnit}-${endTime} ${endUnit}`
                  : "";
                return accumulator;
              },
              {}
            );

            handleAddLocationSubmit(values, opTime, helpers);

            imgRef.current = null;
          }}
          validationSchema={addLocationValidationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="flex sticky py-5 z-40  top-0 w-full bg-white justify-between  gap-4 sm:gap-0 items-start sm:items-center sm:flex-row flex-col">
                <h2 className="text-3xl md:text-4xl  xl:text-5xl  font-md">
                  Create New Site
                </h2>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  loading={isLoadingNewSite}
                  color={"#FB6514"}
                  radius="xl"
                  size="md"
                  className="w-full"
                >
                  Save Changes
                </Button>
              </div>
              <div className="grid pb-[50px] grid-cols-1 md:grid-cols-2  2xl:gap-14  gap-10 2xl:w-[85%] w-full mx-auto xl:mt-20 mt-10 ">
                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Site Name
                  </h2>
                  <p className="text-grayText2 text-base">
                    Enter a unique and recognizable name for the site. This
                    will be used in listings and searches.
                  </p>
                </div>
                <div className="flex flex-col gap-2 ">
                  <input
                    type="text"
                    name="name"
                    value={values.name}
                    className={`${
                      errors.name && touched.name
                        ? "border-alert "
                        : "border-lightGray2"
                    } h-10  rounded-lg px-4 border-1 w-full  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
                    placeholder="Site Name"
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-alert text-xs"
                  />
                </div>
                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Site Location
                  </h2>
                  <p className="text-grayText2 text-base">
                    Specify the exact location of the site, This helps users
                    find the site location.
                  </p>
                </div>

                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <input
                      type="text"
                      name="address"
                      value={values.address}
                      className={`${
                        errors.address && touched.address
                          ? "border-alert "
                          : "border-lightGray2"
                      } h-10 rounded-lg px-4 border-1  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
                      placeholder="Site Location"
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="address"
                      component="div"
                      className="text-alert text-xs"
                    />
                  </div>
                </div>

                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Site Description
                  </h2>
                  <p className="text-grayText2 text-base">
                    Provide a detailed description of the site. This
                    information will help users understand if the site meets
                    their needs.
                  </p>
                </div>
                <div className="flex flex-col gap-2">
                  <input
                    type="text"
                    name="description"
                    value={values.description}
                    className={`${
                      errors.description && touched.description
                        ? "border-alert "
                        : "border-lightGray2"
                    } h-10 rounded-lg px-4 border-1  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
                    placeholder="Site Description"
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="text-alert text-xs"
                  />
                </div>

                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Opening Hours
                  </h2>
                  <p className="text-grayText2 text-base">
                    List the hours during which the site is available for use.
                  </p>
                </div>

                <div className="flex flex-col gap-4 ">
                  {Object.entries(opentingTime).map(([day, value]) => {
                    return (
                      <div
                        className="flex gap-4  w-full items-center "
                        key={day}
                      >
                        <p className="min-w-[90px]">{day}</p>
                        <Switch
                          checked={value.show}
                          label={value.show ? "Opened" : "Closed"}
                          onChange={(e) =>
                            setOpeningTime((prev) => {
                              return {
                                ...prev,
                                [day]: { ...prev[day], show: !prev[day].show },
                              };
                            })
                          }
                        />
                        {value.show && (
                          <div className="grid  grid-flow-col auto-cols-max items-center gap-4 w-full">
                            <TimePicker
                              hours={opentingTime[day].startHours}
                              minutes={opentingTime[day].startMinutes}
                              unit={opentingTime[day].startUnit}
                              setHours={(val) =>
                                setOpeningTime((prev) => {
                                  return {
                                    ...prev,
                                    [day]: {
                                      ...prev[day],
                                      startHours: val,
                                    },
                                  };
                                })
                              }
                              setUnit={(val) =>
                                setOpeningTime((prev) => {
                                  return {
                                    ...prev,
                                    [day]: {
                                      ...prev[day],
                                      startUnit: val,
                                    },
                                  };
                                })
                              }
                              setMinutes={(val) =>
                                setOpeningTime((prev) => {
                                  return {
                                    ...prev,
                                    [day]: {
                                      ...prev[day],
                                      startMinutes: val,
                                    },
                                  };
                                })
                              }
                            />
                            <p className="w-auto mx-auto">To</p>
                            <TimePicker
                              hours={opentingTime[day].endHours}
                              minutes={opentingTime[day].endMinutes}
                              unit={opentingTime[day].endUnit}
                              setHours={(val) =>
                                setOpeningTime((prev) => {
                                  return {
                                    ...prev,
                                    [day]: {
                                      ...prev[day],
                                      endHours: val,
                                    },
                                  };
                                })
                              }
                              setUnit={(val) =>
                                setOpeningTime((prev) => {
                                  return {
                                    ...prev,
                                    [day]: {
                                      ...prev[day],
                                      endUnit: val,
                                    },
                                  };
                                })
                              }
                              setMinutes={(val) =>
                                setOpeningTime((prev) => {
                                  return {
                                    ...prev,
                                    [day]: {
                                      ...prev[day],
                                      endMinutes: val,
                                    },
                                  };
                                })
                              }
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="flex-col flex gap-2 w-[90%] ">
                  <h2 className="font-medium text-xl text-grayText ">
                    Site Picture
                  </h2>
                  <p className="text-grayText2 text-base">
                    Upload high-quality images of the site to give users a
                    visual understanding of the atmosphere.
                  </p>
                </div>

                <div className="flex flex-col gap-2 ">
                  <div
                    className={` min-h-28  relative  cursor-pointer w-full flex-col flex  items-center  border border-solid   justify-center  rounded-md  py-4 px-2 ${
                      errors.imageURL && touched.imageURL
                        ? "border-alert"
                        : "border-lightGray2"
                    }   `}
                  >
                    <input
                      type="file"
                      name="imageURL"
                      accept="image/*"
                      onChange={(e) =>
                        handleUploadImages(e, setFieldValue, "imageURL")
                      }
                      className="absolute  inset-0 opacity-0 sm:text-base text-sm  "
                    />

                    {isloadingImg && !isErrorImg ? (
                      <p className="text-grayText3">
                        uploading image<span className="loading">...</span>
                      </p>
                    ) : isErrorImg ? (
                      <p className="text-grayText3">
                        Image upload failed. Please try again
                      </p>
                    ) : imgRef.current ? (
                      <div>
                        <p>{imgRef.current.name}</p>
                      </div>
                    ) : (
                      <>
                        <div
                          style={{ border: "6px solid #F7F8F9" }}
                          className="flex justify-center items-center rounded-[50%] w-12 h-12 bg-lightGray my-2"
                        >
                          <IoCloudUploadOutline className="text-grayText text-xl" />
                        </div>

                        <p className="text-grayText2 text-base font-medium">
                          <span className="text-action pr-1 ">
                            Click to upload
                          </span>
                          {/* or drag and drop */}
                        </p>
                        <p className="text-grayText2 text-sm">{`SVG, PNG, JPG or GIF (max. 800x400px)`}</p>
                      </>
                    )}
                  </div>

                  <ErrorMessage
                    name="imageURL"
                    component="div"
                    className="text-alert text-xs"
                  />
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

export default NewSpace;

const TimePicker = ({
  hours,
  minutes,
  unit,
  setHours,
  setMinutes,
  setUnit,
}) => {
  const hourOptions = Array.from({ length: 12 }, (_, i) =>
    i < 9 ? `0${i + 1}` : `${i + 1}`
  );
  const minuteOptions = Array.from({ length: 60 }, (_, i) =>
    i < 10 ? `0${i}` : `${i}`
  );
  const ampm = ["AM", "PM"];
  const [open, setOpen] = useState(false);
  const ref = useClickOutside(() => setOpen(false));
  return (
    <div className="relative ">
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="border border-solid border-lightGray2  rounded-lg px-2 w-[100px]"
      >{`${hours}:${minutes} ${unit}`}</div>
      {open && (
        <div
          className=" bg-white flex absolute shadow-lg mt-1 rounded-md z-50 "
          ref={ref}
        >
          <div className="max-h-[200px] overflow-auto w-14 border border-l-1 border-grayText">
            {hourOptions.map((el) => {
              return (
                <span
                  key={el}
                  onClick={() => setHours(el)}
                  className={`cursor-pointer hover:bg-lightGray py-1 flex items-center justify-center ${
                    hours === el ? "bg-lightGray" : "bg-white"
                  }`}
                >
                  {el}
                </span>
              );
            })}
          </div>
          <div className="max-h-[200px] overflow-auto  w-14">
            {minuteOptions.map((el) => {
              return (
                <span
                  key={el}
                  onClick={() => setMinutes(el)}
                  className={`cursor-pointer hover:bg-lightGray py-1 flex items-center justify-center ${
                    minutes === el ? "bg-lightGray" : "bg-white"
                  }`}
                >
                  {el}
                </span>
              );
            })}
          </div>
          <div className="max-h-[200px] overflow-auto  w-14">
            {ampm.map((el) => {
              return (
                <span
                  key={el}
                  onClick={() => setUnit(el)}
                  className={`cursor-pointer hover:bg-lightGray py-1 flex items-center justify-center ${
                    unit === el ? "bg-lightGray" : "bg-white"
                  }`}
                >
                  {el}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
